import { render, staticRenderFns } from "./product-country-flag-row.vue?vue&type=template&id=441c1c8e&"
import script from "./product-country-flag-row.vue?vue&type=script&lang=ts&"
export * from "./product-country-flag-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports